import React from "react";
import { FormControlLabel } from "@mui/material";
import { CircularProgress } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { businessPracticeData } from "../../../assets/data/data";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  SECTION_TITLE,
  SUCCESS_MESSAGE,
  FOOTER_TEXT,
} from "./Business.constants";
import {
  RootBox,
  StyledBackdrop,
  SectionTitleTypography,
  ChecklistItemBox,
  StyledCheckbox,
  UncheckedIcon,
  CheckedIcon,
  LabelTypography,
  LinkTypography,
  FooterTypography,
} from "./Business.styles";
import { useBusinessChecklist } from "./useBusinessChecklist";
import { Gapper } from "../../../components/ui/Gapper";
import { colors } from "../../../theme/theme";

const handleLinkClick = (url) => () => window.open(url, "_blank");

const Business = () => {
  const {
    loading,
    success,
    errorState,
    checkedItems,
    handleCheck,
    clearError,
    clearSuccess,
  } = useBusinessChecklist();

  return (
    <RootBox>
      <StyledBackdrop open={loading}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>

      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={clearError}
        errorMsg={errorState.message}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={clearSuccess}
        text={SUCCESS_MESSAGE}
      />

      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        noIcon
        videoUrl={VIDEO_URL}
      />

      <Gapper gap={20}>
        <SectionTitleTypography>{SECTION_TITLE}</SectionTitleTypography>

        {businessPracticeData.map((item) => (
          <ChecklistItemBox key={item.id}>
            <FormControlLabel
              control={
                <StyledCheckbox
                  checked={checkedItems[item.value]?.checked ?? false}
                  onChange={() => handleCheck(item.value)}
                  icon={<UncheckedIcon />}
                  checkedIcon={<CheckedIcon color={colors.success} />}
                />
              }
              label={
                <>
                  <LabelTypography
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  />
                  {item?.link && (
                    <LinkTypography onClick={handleLinkClick(item.link)}>
                      {item.link}
                    </LinkTypography>
                  )}
                </>
              }
            />
          </ChecklistItemBox>
        ))}
      </Gapper>

      <FooterTypography>{FOOTER_TEXT}</FooterTypography>
    </RootBox>
  );
};

export default Business;
